// Common
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

// Modules
import { MatTooltipModule } from '@angular/material/tooltip';
import { Button2Component } from '@frontendlib/components/components/button/button2.component';
import { ContextMenuItemComponent } from '@frontendlib/components/features/popover/components/context-menu-item/context-menu-item.component';
import { ContextMenuStateIndicatorComponent } from '@frontendlib/components/features/popover/components/context-menu-state-indicator/context-menu-state-indicator.component';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';
import { LoadingIndicatorComponent } from '@frontendlib/components/components/loading-indicator/loading-indicator.component';
import { NoContentStubComponent } from '@frontendlib/components/components/no-content-stub/no-content-stub.component';
import { CalendarAppModule } from '@modules/calendar-app/calendar-app.module';
import { ConnectionsModule } from '@modules/connections/connections.module';
import { ContactsModule } from '@modules/contacts/contacts.module';
import { FilesModule } from '@modules/files/files.module';
import { SheetsModule } from '@modules/sheets/sheets.module';
import { KnotsModule } from '@modules/knots/knots.module';
import { MessagesModule } from '@modules/messages/messages.module';
import { NotesModule } from '@modules/notes/notes.module';
import { SplitViewModule } from '@modules/split-view/split-view.module';
import { TagsModule } from '@modules/tags/tags.module';
import { TasksModule } from '@modules/tasks/tasks.module';
import { UtilsModule } from '@modules/utils/utils.module';
import { CommonModule as AppCommonModule } from '../common/common.module';

// Components
import { FiltersPanelComponent } from '@modules/knowledge/components/filters-panel/filters-panel.component';
import { KnowledgeCalendarsSectionComponent } from './components/calendars-section/calendars-section.component';
import { KnowledgeConnectionsSectionComponent } from './components/connections-section/connections-section.component';
import { KnowledgeContactsSectionComponent } from './components/contacts-section/contacts-section.component';
import { KnowledgeEventsSectionComponent } from './components/events-section/events-section.component';
import { KnowledgeFilesSectionComponent } from './components/files-section/files-section.component';
import { KnowledgeFoldersSectionComponent } from './components/folders-section/folders-section.component';
import { KnowledgeSheetFoldersSectionComponent } from './components/sheet-folders-section/sheet-folders-section.component';
import { KnowledgeSheetsSectionComponent } from './components/sheets-section/sheets-section.component';
import { KnowledgeGroupsSectionComponent } from './components/groups-section/groups-section.component';
import { KnowledgeKnotsSectionComponent } from './components/knots-section/knots-section.component';
import { KpSelectionResultsComponent } from './components/kp-selection-results/kp-selection-results.component';
import { KnowledgePanelComponent } from './components/knowledge-panel/knowledge-panel.component';
import { KPResultsEmptyComponent } from './components/kp-results-empty/kp-results-empty.component';
import { KnowledgeMailFoldersSectionComponent } from './components/mail-folders-section/mail-folders-section.component';
import { KnowledgeMessagesSectionComponent } from './components/messages-section/messages-section.component';
import { KnowledgeNotebooksSectionComponent } from './components/notebooks-section/notebooks-section.component';
import { KnowledgeNotesSectionComponent } from './components/notes-section/notes-section.component';
import { KnowledgeProjectsSectionComponent } from './components/projects-section/projects-section.component';
import { KpResultsHeaderComponent } from './components/kp-results-header/kp-results-header.component';
import { KpKeywordChipComponent } from './components/kp-keyword-chip/kp-keyword-chip.component';
import { KpSearchComponent } from './components/kp-search/kp-search.component';
import { KnowledgeTagsSectionComponent } from './components/tags-section/tags-section.component';
import { KnowledgeTasksSectionComponent } from './components/tasks-section/tasks-section.component';

// Directives
import { MatIconModule } from '@angular/material/icon';
import { CalendarAppContextDirective } from '@modules/calendar-app/directives/app-calendar-app-context.directive';
import { ContactsAppContextDirective } from '@modules/contacts/directives/app-contacts-app-context.directive';
import { FilesAppContextDirective } from '@modules/files/directives/app-files-app-context.directive';
import { MailAppContextDirective } from '@modules/messages/directives/app-mail-app-context.directive';
import { NotesAppContextDirective } from '@modules/notes/directives/app-notes-app-context.directive';
import { SheetsAppContextDirective } from '@modules/sheets/directives/app-sheets-app-context.directive';
import { TaskingAppContextDirective } from '@modules/tasks/directives/app-tasking-app-context.directive';

@NgModule({
  imports: [
    AppCommonModule,
    Button2Component,
    CalendarAppModule,
    CommonModule,
    ConnectionsModule,
    ContactsModule,
    FilesModule,
    SheetsModule,
    FormsModule,
    KnotsModule,
    MatIconModule,
    MatTooltipModule,
    MessagesModule,
    NotesModule,
    ContextMenuItemComponent,
    ContextMenuStateIndicatorComponent,
    Button2Component,
    IconComponent,
    SplitViewModule,
    TagsModule,
    TasksModule,
    UtilsModule,
    NoContentStubComponent,
    LoadingIndicatorComponent,
    ContactsAppContextDirective,
    CalendarAppContextDirective,
    FilesAppContextDirective,
    NotesAppContextDirective,
    SheetsAppContextDirective,
    MailAppContextDirective,
    TaskingAppContextDirective,
    KPResultsEmptyComponent,
    KpResultsHeaderComponent,
    KpKeywordChipComponent,
    KpSearchComponent,
  ],
  declarations: [
    // Components
    FiltersPanelComponent,
    KnowledgeCalendarsSectionComponent,
    KnowledgeConnectionsSectionComponent,
    KnowledgeKnotsSectionComponent,
    KnowledgeContactsSectionComponent,
    KnowledgeEventsSectionComponent,
    KnowledgeFilesSectionComponent,
    KnowledgeFoldersSectionComponent,
    KnowledgeSheetFoldersSectionComponent,
    KnowledgeSheetsSectionComponent,
    KnowledgeGroupsSectionComponent,
    KnowledgeMailFoldersSectionComponent,
    KnowledgeMessagesSectionComponent,
    KnowledgeNotebooksSectionComponent,
    KnowledgeNotesSectionComponent,
    KnowledgeProjectsSectionComponent,
    KnowledgeTasksSectionComponent,
    KnowledgePanelComponent,
    KpSelectionResultsComponent,
    KnowledgeTagsSectionComponent,
  ],
  exports: [KnowledgePanelComponent, KpSelectionResultsComponent],
  providers: [],
})
export class KnowledgeModule {}
